import React from 'react';
import { Heart, TrendingUp, Clock, Target, BarChart, TrendingDown, Sparkles, Users } from 'lucide-react';

const CallCentersKPIs = () => {
  const kpis = [
    { icon: Heart, text: 'Higher CSAT and NPS' },
    { icon: TrendingUp, text: 'Faster agent ramp time' },
    { icon: Clock, text: 'Lower AHT' },
    { icon: Target, text: 'Improved FCR' },
    { icon: BarChart, text: 'More consistent QA scores' },
    { icon: TrendingDown, text: 'Fewer escalations' },
    { icon: Sparkles, text: 'Higher agent confidence and retention' },
    { icon: Users, text: 'Reduced manager coaching hours' }
  ];

  return (
    <section className="py-24 px-6 bg-gradient-to-b from-transparent to-blue-950/20">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">
            Results Contact Center <span className="text-cyan-400">Leaders Track</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
          {kpis.map((kpi, index) => {
            const Icon = kpi.icon;
            return (
              <div
                key={index}
                className="p-6 rounded-xl bg-gradient-to-br from-gray-900/80 to-blue-900/20 border border-cyan-500/30 hover:border-cyan-400/60 hover:shadow-lg hover:shadow-cyan-500/20 transition-all duration-300 text-center"
              >
                <Icon className="w-10 h-10 text-cyan-400 mx-auto mb-4" />
                <p className="text-gray-300">{kpi.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CallCentersKPIs;
